module.exports = __webpack_public_path__ + "static/media/alert.700fd7a0.svg";